import NakedDropdown from '@app/components/inputs/NakedDropdown';
import { LocaleAwareDropdownItem } from '@app/components/LocaleAwareComponents';
import { CANADA_PROVINCES, getStatesOrder } from '@app/domain/states';
import styled from '@emotion/styled';
import i18n from 'i18next';
import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  placeholder: string;
  value?: string;
  onChange?: (value: string) => void;
}

const CanadaProvincesDropdown = forwardRef<any, Props>(({ name, placeholder, value, onChange }, ref) => {
  const { t } = useTranslation();

  return (
    <NakedDropdown
      ref={ref}
      accessibilityLabel={t('general.accessibility.province')}
      name={name}
      dataTestId={name}
      placeholder={t<string>(placeholder)}
      isSearchable
      value={value}
      onChange={onChange}
    >
      {getStatesOrder(CANADA_PROVINCES, i18n.language, (name) => t(`supplierValidation.provinces.${name}`)).map((province) => {
        const provinceValue = CANADA_PROVINCES[province];
        return (
          <ProvinceDropdownItem
            key={province}
            keywords={[t(`supplierValidation.provinces.${province}`), province]}
            value={provinceValue}
            textWhenSelected={`supplierValidation.provinces.${province}`}
          >
            <div>{t(`supplierValidation.provinces.${province}`)}</div>
          </ProvinceDropdownItem>
        );
      })}
    </NakedDropdown>
  );
});

CanadaProvincesDropdown.displayName = 'CanadaProvincesDropdown';

const ProvinceDropdownItem = styled(LocaleAwareDropdownItem)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  letter-spacing: 0.1px;
  color: var(--transparent-black-600);
`;

export default CanadaProvincesDropdown;
